import { useEffectOnce } from "react-use";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Card, CodeValidationForm, Layout } from "../components";
import { useLogin } from "../hooks/use-login";
import { safeTrackEvent, verificationViewEvent } from "../tracking/events";

export const Login = () => {
  const { handleLogin, loginError, createOrderError, isLoading } = useLogin();

  useEffectOnce(() => {
    safeTrackEvent(() => verificationViewEvent({ method: "account" }), "verification_view", "login mount");
  });

  return (
    <IntersectionFadeIn>
      <Layout>
        <Card>
          <CodeValidationForm
            onSubmit={handleLogin}
            error={loginError || createOrderError}
            isLoading={isLoading}
            method="account"
          />
        </Card>
      </Layout>
    </IntersectionFadeIn>
  );
};
